import { activeTimeOffTypes, isTimeOffType, timeTypeCode, STANDARD_TIME } from '@/lib/constants/timeTypes'
import { isTimeOffEligible } from '@/lib/constants/employeeTypes'

export function timeOffTypesToShow (employeeTypeId, timeTypesList) {
  return isTimeOffEligible(employeeTypeId) ? activeTimeOffTypes(timeTypesList) : []
}

function blankEntry (template, timeTypeId) {
  return {
    id: null,
    assignmentId: template.assignmentId,
    userId: template.userId,
    clientId: template.clientId,
    staffId: template.staffId,
    date: template.date,
    dayOfTheWeek: template.dayOfTheWeek,
    hours: 0,
    timeTypeId,
    blocked: template.blocked
  }
}

function buildRow (entry, editable) {
  return {
    timeTypeId: entry.timeTypeId,
    label: timeTypeCode(entry.timeTypeId),
    editable: editable && !entry.blocked,
    originalHours: entry.hours,
    entry
  }
}

export function buildTimeSheetDays (entries, timeOffTypes) {
  const entriesByDate = new Map()
  for (const entry of entries || []) {
    const normalized = { ...entry, timeTypeId: entry.timeTypeId || STANDARD_TIME }
    if (!entriesByDate.has(entry.date)) {
      entriesByDate.set(entry.date, [])
    }
    entriesByDate.get(entry.date).push(normalized)
  }

  const editableTypeIds = [STANDARD_TIME, ...timeOffTypes.map(type => type.id)]

  return [...entriesByDate.entries()].map(([date, dateEntries]) => {
    const template = dateEntries[0]
    const stored = typeId => dateEntries.find(entry => entry.timeTypeId === typeId)
    const editableRows = editableTypeIds.map(typeId => buildRow(stored(typeId) || blankEntry(template, typeId), true))
    const readOnlyRows = dateEntries
      .filter(entry => !editableTypeIds.includes(entry.timeTypeId))
      .map(entry => buildRow(entry, false))

    return {
      date,
      dayOfTheWeek: template.dayOfTheWeek,
      blocked: template.blocked,
      rows: [...editableRows, ...readOnlyRows]
    }
  })
}

export function changedEntries (days) {
  return days
    .flatMap(day => day.rows)
    .filter(row => row.editable && row.entry.hours !== row.originalHours)
    .map(row => row.entry)
}

// Time Off is not work, so it is reported beside the worked total rather than inside it.
export function weekTotals (days, timeTypesList) {
  return days
    .flatMap(day => day.rows)
    .reduce((totals, row) => {
      const hours = parseFloat(row.entry.hours) || 0
      return isTimeOffType(timeTypesList, row.timeTypeId)
        ? { ...totals, timeOffHours: totals.timeOffHours + hours }
        : { ...totals, workedHours: totals.workedHours + hours }
    }, { workedHours: 0, timeOffHours: 0 })
}
